import './SharedChannelsListing.css';
import React, { useState } from 'react';
import { canUseDOM, get, getDictionaryItem, getPageThemeColors, replaceUrlPluses } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import LoadMore from '../DynamicListingComponent/LoadMore';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import { ReactComponent as IconDownChevron } from '../../resources/icons/chevronDownCarouselSharedCh.svg';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from './Filters';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
import { convertQueryParamsToFacets } from './index';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { usePrevious } from '../../utils/usePrevious';
import { convertToAnalyticObject } from '../../utils/analytics';
import { checkJssError } from '../../utils/checkJssError';
import { commonListingLtrStyles, commonListingRtlStyles, commonListingStyles } from '../Listing/commonListingStyles';
import { hexToRgb } from '../../utils/hexToRgb';
import { TEXT_SEARCH_FACET_NAME } from '../102_ListingOffersAndDeals/constants';
import { SharedChannelCards } from '../atoms/SharedChannelsCards/SharedChannelsCards';
const getFacetNamesValue = filterData => {
  if (filterData) {
    return filterData.values.map(filter => get(filter, 'fieldNameItem.item.fieldName.value'));
  } else {
    return [];
  }
};
const getDefaultSearchValue = location => canUseDOM ? replaceUrlPluses(qsToObject(location.search)[TEXT_SEARCH_FACET_NAME]) || '' : '';
const SharedChannelsListingComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const location = useLocation();
  const currentLang = get(sitecoreContext, 'language');
  const searchIndexParams = get(params, 'SearchIndex', '');
  const typeArray = get(fields, 'data.configuration.contentType.types') || [];
  const filterData = get(fields, 'data.configuration.filters') || [];
  const filterValue = get(fields, 'data.configuration.filters.values') || [];
  const title = get(fields, 'data.configuration.title.jss.value');
  const pagesize = Number(get(fields, 'data.configuration.pageSize.jss.value'));
  const isSumOrFiltersScores = get(fields, 'data.configuration.isSumOrFiltersScores.jss.value', false);
  const dictionary = get(fields, 'data.dictionary');
  const buttonsDictionary = get(fields, 'data.buttonsDictionary');
  const allTagLabel = getDictionaryItem(dictionary, "all") || "All";
  const LoadMoreCopy = getDictionaryItem(dictionary, 'LoadMore');
  const showResultsLabel = getDictionaryItem(dictionary, 'ShowResults') || 'Show Results';
  const clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'ClearAll';
  const FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'Filters';
  const viewedNofMLabel = `${getDictionaryItem(dictionary, 'YouHaveViewed')} {#loadedHits#} ${getDictionaryItem(dictionary, 'Of')} {#nbHits#} ${getDictionaryItem(dictionary, 'Items')}`;
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  const [result, setResult] = React.useState();
  const [facets, setFacets] = React.useState();
  const [defaultFacets, setdefaultFacets] = React.useState();
  const [facetsStats, setFacetsStats] = React.useState({});
  const [hits, setHits] = React.useState([]);
  const [nbHits, setNbHits] = React.useState(0);
  const [page, setpage] = React.useState(0);
  const [firstRendering, setFirstRendering] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [buttonPressed, setButtonPressed] = React.useState(false);
  const [countAlgoliaCalls, setCountAlgoliaCalls] = React.useState(0);
  const [isTypeSetToUrl, setIsTypeSetToUrl] = React.useState(false);
  const [searchTextValue, setSearchTextValue] = useState(() => getDefaultSearchValue(location));
  const [resetFilter, setResetFilter] = React.useState(false);
  const [resetAllFilters, setResetAllFilters] = React.useState(false);
  const [setFilters, applySetFilters] = React.useState(false);
  const [closeComponent, setCloseComponent] = React.useState(false);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const isFirstLoadWithoutFacets = React.useRef(false);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  React.useEffect(() => {
    if (canUseDOM && document.body) {
      document.body.style.setProperty('--service-listing-primary-color-with-opacity-01', hexToRgb(selectedPrimaryColor).concat(", 0.1"));
      document.body.style.setProperty('--service-listing-primary-color-with-opacity-02', hexToRgb(selectedPrimaryColor).concat(", 0.2"));
    }
  }, []);
  const queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (let key in queryParams) {
      queryParams[key] = queryParams[key];
    }
  }
  let facetFilters = convertQueryParamsToFacets(queryParams, true, filterData);
  let prevFacetFilters = usePrevious(facetFilters);
  const prevPage = usePrevious(page);
  React.useEffect(() => {
    const queryIndexes = Object.keys(queryParams).filter(k => k.indexOf(`${searchIndexParams}_asc_`) > -1)[0];
    let algoliaIndexes = '';
    if (queryIndexes) {
      algoliaIndexes = queryIndexes;
    } else {
      algoliaIndexes = get(params, 'SearchIndex');
    }
    let types = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      return `type:${value}`;
    });
    const facetNames = getFacetNamesValue(filterData);
    let filters;
    if (queryParams.valid) {
      filters = queryParams.valid.split('+').join(' ');
    }
    const isContainsType = facetFilters.some(subArray => subArray.some(item => item.startsWith('category:')));
    const isAllTagSelected = facetFilters.some(subArray => subArray.some(item => item.includes(allTagLabel)));
    const itemFilters = {
      query: searchTextValue,
      filters,
      facets: [...facetNames],
      facetFilters: isAllTagSelected ? [[...types]] : [[...types], ...facetFilters],
      hitsPerPage: pagesize,
      page: page
    };
    const removeTypeFromArray = arr => arr.filter(subArray => !subArray.some(item => item.startsWith('category:')));
    const facetFiltersWithoutType = removeTypeFromArray(facetFilters);
    const switchItemFilters = {
      facets: [...facetNames],
      facetFilters: [[...types], ...facetFiltersWithoutType]
    };
    const listingRequest = () => {
      setLoading(true);
      if (isContainsType) {
        getListing(algoliaIndexes, itemFilters, algoliaSettings, undefined, isSumOrFiltersScores).then(response => {
          setCountAlgoliaCalls(prev => prev + 1);
          setResult(response);
          applySetFilters(false);
          setNbHits(response.nbHits);
          if (response.hits.length) {
            if (buttonPressed) {
              setButtonPressed(false);
              const resultsBlocks = document.querySelectorAll('.results');
              if (resultsBlocks.length) {
                const lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
                const focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
                if (focusableList.length) {
                  const lastFocusable = focusableList[focusableList.length - 1];
                  lastFocusable.focus();
                }
              }
            }
            setHits(hits.concat(response.hits));
          }
          setTimeout(function () {
            if (canUseDOM) {
              window.onscroll = () => {};
            }
          }, 100);
          setFirstRendering(false);
          setResetAllFilters(false);
        }).catch(error => {
          console.error('Error:', error);
          setCloseComponent(true);
        }).finally(() => setLoading(false));
      }
      getListing(algoliaIndexes, switchItemFilters, algoliaSettings, undefined, isSumOrFiltersScores).then(response => {
        if (countAlgoliaCalls === 0) {
          setdefaultFacets(response.facets);
        }
        setFacets(response.facets);
      }).catch(error => {
        console.error('Error:', error);
        setCloseComponent(true);
      }).finally(() => setLoading(false));
    };
    if (resetAllFilters) {
      listingRequest();
    } else if (setFilters) {
      listingRequest();
    } else if (isTypeSetToUrl && countAlgoliaCalls <= 1) {
      setIsTypeSetToUrl(false);
      listingRequest();
    } else {
      if (!isFirstLoadWithoutFacets.current) {
        // compare previous facet filters value to escape extra request

        if (prevFacetFilters && prevFacetFilters.length === 0) {
          prevFacetFilters = undefined;
        }
        if (JSON.stringify(facetFilters) !== JSON.stringify(prevFacetFilters) || page !== prevPage) {
          listingRequest();
        }
      } else {
        isFirstLoadWithoutFacets.current = false;
      }
    }
  }, [resetFilter, setFilters, page, buttonPressed, resetAllFilters, isTypeSetToUrl]);
  if (closeComponent) {
    console.info('SharedChannelsCarousel component render skipped. No fields provided');
    return null;
  }
  const resetFilterCallback = () => {
    setFacets(undefined);
    setResult(undefined);
    setHits([]);
    setpage(0);
    setResetFilter(true);
  };
  const resetAllFiltersCallback = () => {
    setResetAllFilters(true);
  };
  const {
    filterShowResultsAnalytics,
    filterClearAllDateAnalytics,
    filterClickAnalytics
  } = fields.data;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const loadMore = () => {
    if (canUseDOM) {
      window.onscroll = () => {
        window.scrollTo(window.scrollX, window.scrollY);
      };
    }
    setButtonPressed(true);
    setpage(prevState => prevState + 1);
    if (eventsAnalytics['loadMoreAnalytics']) {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['loadMoreAnalytics'], params));
    }
  };
  const setListingFilter = () => {
    setpage(0);
    setHits([]);
    applySetFilters(true);
    setFacetsStats(result && result.facets_stats);
    isFirstLoadWithoutFacets.current = firstRendering && facetFilters.length === 0;
  };
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    componentTabIndex: "disabled"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "Listing"
  }, filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    fields: filterData,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showResultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    FiltersCopy: FiltersCopy,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    allTagLabel: allTagLabel,
    buttonsDictionary: buttonsDictionary,
    firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
    eventsAnalytics: eventsAnalytics,
    analytics: {
      filterShowResultsAnalytics,
      filterClearAllDateAnalytics,
      filterClickAnalytics,
      params
    },
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndexParams,
    setIsTypeSetToUrl: setIsTypeSetToUrl,
    searchTextValue: searchTextValue,
    setSearchTextValue: setSearchTextValue
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "serviceListingTitle"
  }, title), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))), /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row containerGap"
  }, hits && hits.map((hit, index) => /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-sm-6 col-lg-4 col-xl-3 cardContainer",
    key: index
  }, /*#__PURE__*/React.createElement(SharedChannelCards, {
    hit: hit,
    rtl: rtl,
    BASE_URL: BASE_URL
  }))))))), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: LoadMoreCopy,
    onClick: loadMore,
    nbHits: result.nbHits,
    loadedHits: (page + 1) * pagesize,
    viewedNofMLabel: viewedNofMLabel,
    icon: /*#__PURE__*/React.createElement(IconDownChevron, {
      className: "chevronIcon"
    })
  })))));
};
const SharedChannelsListing = props => checkJssError(props, SharedChannelsListingComponent, props.fields.data.configuration);
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${loadMoreButtonStylesLtr} ${commonStyles} 
    ${rtl ? stylesRTL : stylesLTR} ${commonListingStyles}
    ${rtl ? commonListingRtlStyles : commonListingLtrStyles}`
  }, children);
};
export const commonStyles = "c18zb4z";
export const stylesLTR = "s1lhj30m";
export const stylesRTL = "s1qkmw3x";
export default SharedChannelsListing;